<template>
    <a-modal title="添加项目" :visible="visible" width="70%" :confirm-loading="confirmLoading" cancelText="取消" okText="确定"  @ok="handleOk" @cancel="handleCancel">
        <a-form-model ref="ruleForm" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
            <a-row type="flex" justify="space-around">
                <a-col :span="12">
                    <a-form-model-item ref="projectId" label="挂牌项目" prop="projectId">
                        <a-select style="width: 423px" v-model="form.projectId" placeholder="请选择挂牌项目">
                            <a-select-option v-for="(ele,index) in quotationProjectList" :key="index" :value="ele.project_id">{{ ele.project_name }}</a-select-option>
                         </a-select>
                    </a-form-model-item>
                </a-col>
                <a-col :span="12">
                    <a-form-model-item ref="quotationType" label="挂牌类型" prop="quotationType">
                        <a-select style="width: 423px" v-model="form.quotationType" placeholder="请选择挂牌类型">
                            <a-select-option value="0">信用挂牌</a-select-option>
                            <a-select-option value="1">流转保证金挂牌</a-select-option>
                        </a-select>
                    </a-form-model-item>
                </a-col>
            </a-row>
            <a-row type="flex" justify="space-around">
                <a-col :span="12">
                    <a-form-model-item ref="quotationPrice" label="挂牌价" prop="quotationPrice">
                        <a-input addon-after="万元" v-model="form.quotationPrice" placeholder="请输入挂牌价格(万元)" />
                    </a-form-model-item>
                </a-col>
                <a-col :span="12">
                    <a-form-model-item ref="contactName" label="联系人" prop="contactName">
                        <a-input v-model="form.contactName" placeholder="请输入联系人姓名" />
                    </a-form-model-item>
                </a-col>
            </a-row>
            <a-row type="flex">
                <a-col :span="12">
                    <a-form-model-item ref="contactPhone" label="联系电话" prop="contactPhone">
                        <a-input v-model="form.contactPhone" placeholder="请输入联系人电话"  />
                    </a-form-model-item>
                </a-col>
            </a-row>
        </a-form-model>
    </a-modal>        
</template>

<script>
export default {
    data(){
        return{
            visible:false,
            confirmLoading: false,
            labelCol: { span: 4 },
            wrapperCol: { span: 20 }, 
            form:{
               projectId:undefined,
               quotationType:undefined,
               quotationPrice:'',
               contactName:'',
               contactPhone:''
            },
            rules:{
                projectId:[
                    {
                        required: true,
                        message: "请选择挂牌项目",
                        trigger: "change",
                    }
                ],
                quotationType:[
                    {
                        required: true,
                        message: "请选择挂牌类型",
                        trigger: "change",
                    }
                ],
                quotationPrice:[
                    {
                        required: true,
                        message: "请输入挂牌价格",
                        trigger: "blur",
                    }
                ],
                contactName:[
                    {
                        required: true,
                        message: "请输入联系人姓名",
                        trigger: "blur",
                    }
                ],
                contactPhone:[
                    {
                        required: true,
                        message: "请输入联系人号码",
                        trigger: "blur",
                    },
                    {
                        pattern: /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/,
                        message: '请输入正确的手机号',
                        trigger: "blur", 
                    }    
                ]
            },
            quotationProjectList:[]
        }
    },
    created(){
        this.$https.get('/portal/listing/quotationProject').then(res=>{
            if(res.code == 200){
                this.quotationProjectList = res.rows;
            }
        })
    },
    methods:{
        showDiolag(){
            this.clear();
            this.visible = true;
        },
        handleOk(){
          this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    this.confirmLoading = true;
                    this.$https.post('/portal/listing/addProjectQuotation',this.form).then(res=>{
                            this.confirmLoading = false;
                            if(res.code == 200){
                                this.$message.success('保存成功');
                                this.clear();
                                this.$emit('getDataList')
                                this.visible = false;
                            }else{
                                this.$message.error(res.msg);
                            }
                    }).catch(error=>{
                        this.confirmLoading = false;
                    })
                } else {
                    console.log("error submit!!");
                    return false;
                }
            });
        },
        handleCancel(e) {
            this.visible = false;
        },
        clear(){
            this.form = {
               projectId:undefined,
               quotationType:undefined,
               quotationPrice:'',
               contactName:'',
               contactPhone:''
            }
        },
    }
}
</script>

<style>

</style>